export default "__VITE_ASSET__CWfL_06___"